/**
 * Fetch open public comment periods from Federal Register API (public, no auth).
 * Matches mobile logic: PRORULE + NOTICE, comments_close_on >= today, sorted by close date.
 */
export async function fetchFederalRegisterCommentPeriods() {
  try {
    const todayStr = new Date().toISOString().slice(0, 10);
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 90);
    const fromStr = fromDate.toISOString().slice(0, 10);

    const params = new URLSearchParams();
    params.append("conditions[type][]", "PRORULE");
    params.append("conditions[type][]", "NOTICE");
    params.append("conditions[publication_date][gte]", fromStr);
    params.append("order", "newest");
    params.append("per_page", "100");
    ["title", "html_url", "publication_date", "comments_close_on", "comment_url", "regulations_dot_gov_url", "regulations_dot_gov_info", "docket_id", "docket_ids"].forEach((f) => params.append("fields[]", f));

    const url = `https://www.federalregister.gov/api/v1/documents.json?${params.toString()}`;
    const res = await fetch(url);
    if (!res.ok) return [];

    const data = await res.json();
    const results = Array.isArray(data?.results) ? data.results : [];
    const openDocuments = results.filter((doc) => {
      const closeDate = doc?.comments_close_on;
      return closeDate && closeDate >= todayStr;
    });
    openDocuments.sort((a, b) => (a.comments_close_on || "").localeCompare(b.comments_close_on || ""));
    const topDocs = openDocuments.slice(0, 3);
    return topDocs.map((doc) => {
      const submitUrl = doc.comment_url || doc.regulations_dot_gov_url || doc.html_url;
      return {
        title: doc.title,
        closeDate: doc.comments_close_on,
        submitUrl,
        frUrl: doc.html_url,
        raw: doc,
      };
    });
  } catch (err) {
    console.error("[Federal Register] Error fetching comment periods:", err);
    return [];
  }
}
